import React from 'react';
import { Button, TooltipIcon, CheckBox, TextArea, CheckResultCircle } from '../../components';
import { INFO_ICON, SAVE_ICON } from '../../utils/consts';
import styles from './AccordionItem.module.css';

const AccordionItem = ({ check }) => {
	const { check_name, check_description, is_mandatory } = check;

	return (
		<div className={`accordion-item ${styles.accordionItem}`}>
			<h5 className={`accordion-header ${styles.accordionHeader}`}>
				<div className={`d-flex px-2 align-items-center`}>
					<CheckBox id={`select-${check.check_id}`} classes='background-primary' />
					<button
						type='button'
						className={`accordion-button fw-semibold color-header collapsed ${styles.accordionButtonIcon}`}
						data-bs-toggle='collapse'
						aria-expanded='false'
						data-bs-target={`#collapse${check.check_id}`}
						aria-controls={`collapse${check.check_id}`}>
						<div className='d-flex w-100 justify-content-between align-items-center gap-3'>
							<span>{check_name}</span>
							<div className='d-flex gap-3'>
								<CheckResultCircle
									bg={is_mandatory ? 'color-green' : 'color-red'}
								/>
								<TooltipIcon
									classes={'me-3'}
									tooltip={check_description}
									icon={INFO_ICON}
								/>
							</div>
						</div>
					</button>
				</div>
			</h5>
			<div
				id={`collapse${check.check_id}`}
				className='accordion-collapse collapse'
				data-bs-parent='#accordionExample'>
				<div className='accordion-body background-secondary'>
					<p>"result_data" vom Check als Klartext</p>
					<CheckBox
						id={`checkbox-${check.check_id}`}
						label='Test erfolgreich'
						classes='background-tertiary'
					/>
					<TextArea
						label='Ergänzungen...'
						classes='background-tertiary'
						style={{ minHeight: '100px', maxHeight: '200px' }}
					/>
					<div className='d-flex justify-content-end'>
						<Button icon={SAVE_ICON} classes='background-blue px-3'>
							Speichern
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AccordionItem;
